import { render, staticRenderFns } from "./DhcpOption82PortConfig.vue?vue&type=template&id=10b2abd0&"
import script from "./DhcpOption82PortConfig.vue?vue&type=script&lang=js&"
export * from "./DhcpOption82PortConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports